import React from 'react';

import { Segment } from '@mairistem/composants';

import { useCreateFiche } from '@mairistem/fiche';

import './Mouvement.less';

import { getSymbol, Icon, TreeSymbol } from '@mairistem/finances-utils';
import type { Exercice } from '@mairistem/comptabilite';
import type { TreeRow } from '../../../../interfaces/pieces/TreeRow';
import CODE_BHM from '../../../../constants/mouvements/codeBHM';
import getMouvementIcon from '../../../../utils/getMouvementIcon';

interface CreateMouvementRowProps {
  rowData: TreeRow;
  exercice: Exercice;
}

const CreateMouvementRow = ({ rowData, exercice }: CreateMouvementRowProps) => {
  const createFiche = useCreateFiche({ path: '/liquidations' });

  const parent: TreeRow = getSymbol(rowData, TreeSymbol.PARENT);

  const childrens: TreeRow[] = parent.children;

  const handleCreateNewMouvement = React.useCallback((): void => {
    createFiche({
      identifiantBordereau: parent.bordereau?.identifiant ?? null,
      identifiantExercice: exercice?.identifiant,
      identifiantEntite: exercice?.identifiantEntite,
      bordereau: parent.bordereau,
      sens: parent?.bordereau?.sens,
      codeBHM: CODE_BHM.VALUE.BROUILLARD,
      exercice,
    });
  }, [createFiche, exercice, parent.bordereau]);

  return (
    <Segment className="create-row mouvement-container" onClick={handleCreateNewMouvement}>
      {childrens.length > 1
        ? getMouvementIcon(childrens[1].mouvement)
        : <Icon name="FilePlus2" iconSet="Lucide" />}
      {rowData.libelle}
    </Segment>
  );
};
export default CreateMouvementRow;
